import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./styles.scss";
import { Sidebar, Footer, ScrollToTop } from "./components";
import { AuthContext } from "./contexts/AuthContext";
import { useStateContext } from "./contexts/ContextProvider";
import {
  Login,
  ProfilUser,
  UbahProfilUser,
  DaftarUser,
  TambahUser,
  UbahUser,
  TutupPeriode,
  TampilGantiPeriode,
  TampilSetting,
  UbahSetting,
  TampilKategori,
  UbahKategori,
  TambahKategori,
  TampilBarang,
  UbahBarang,
  TambahBarang,
  TampilJenisCOA,
  TambahJenisCOA,
  UbahJenisCOA,
  TampilGroupCOA,
  TambahGroupCOA,
  UbahGroupCOA,
  TampilSubGroupCOA,
  TambahSubGroupCOA,
  UbahSubGroupCOA,
  TampilCOA,
  TambahCOA,
  UbahCOA,
  TampilSupplier,
  UbahSupplier,
  TambahSupplier,
  TampilPelanggan,
  UbahPelanggan,
  TambahPelanggan,
  TampilCabang,
  UbahCabang,
  TambahCabang,
  TampilDaftarStokToko,
  TampilKoreksiStokToko,
  TambahKoreksiStokToko,
  TampilDaftarBeli,
  TambahSupplierFromBeli,
  TambahBeli,
  TampilBeli,
  UbahBeli,
  TambahBeliChild,
  UbahBeliChild,
  TambahBarangFromBeliChild,
  TampilBeliChild,
  TampilPembayaranHutang,
  TambahPembayaranHutang,
  TampilDaftarJual,
  TambahJual,
  TampilJual,
  UbahJual,
  TambahPelangganFromJual,
  TambahJualChild,
  TampilJualChild,
  TampilPembayaranPiutang,
  TambahPembayaranPiutang,
  LaporanStokBarang,
  LaporanPembelianBarang,
  LaporanPembelian,
  LaporanPenjualan,
  LaporanPenjualanRinci,
  LaporanBarangHpp,
  TampilDaftarKasMasuk,
  TambahKasMasuk,
  TampilKasMasuk,
  UbahKasMasuk,
  TambahKasMasukChild,
  TampilKasMasukChild,
  UbahKasMasukChild,
  TampilDaftarKasKeluar,
  TambahKasKeluar,
  TampilKasKeluar,
  UbahKasKeluar,
  TambahKasKeluarChild,
  TampilKasKeluarChild,
  UbahKasKeluarChild,
  TampilDaftarBankMasuk,
  TambahBankMasuk,
  TampilBankMasuk,
  UbahBankMasuk,
  TambahBankMasukChild,
  TampilBankMasukChild,
  UbahBankMasukChild,
  TampilDaftarBankKeluar,
  TambahBankKeluar,
  TampilBankKeluar,
  UbahBankKeluar,
  TambahBankKeluarChild,
  TampilBankKeluarChild,
  UbahBankKeluarChild,
  Posting,
  Unposting,
  AktivitasBukuBesar,
  NeracaSaldo,
  LabaRugi,
  Neraca,
  Jurnal,
} from "./pages/index";
import { FaBars } from "react-icons/fa";

const App = () => {
  const { screenSize, setScreenSize } = useStateContext();
  const { user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  const USERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user) {
      return children;
    }

    return <Navigate to="/login" />;
  };

  const PROFILUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.profilUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const DAFTARUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.daftarUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const TUTUPPERIODERoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.tutupPeriode) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const GANTIPERIODERoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.gantiPeriode) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SETTINGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.setting) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KATEGORIRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kategori) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BARANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.barang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BUKUBESARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bukuBesar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SUPPLIERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.supplier) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PELANGGANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pelanggan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const CABANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.cabang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const STOKTOKORoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.stokToko) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KOREKSISTOKTOKORoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.koreksiStokToko) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PEMBELIANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pembelian) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PEMBAYARANHUTANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pembayaranHutang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PENJUALANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.penjualan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PEMBAYARANPIUTANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.pembayaranPiutang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANSTOKBARANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanStokBarang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPEMBELIANBARANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPembelianBarang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPEMBELIANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPembelian) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANPENJUALANRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanPenjualan) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPORANBARANGHPPRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.laporanBarangHpp) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KASMASUKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kasMasuk) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KASKELUARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kasKeluar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BANKMASUKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bankMasuk) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const BANKKELUARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.bankKeluar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const POSTINGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.posting) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const AKTIVITASBUKUBESARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.aktivitasBukuBesar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const NERACASALDORoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.neracaSaldo) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const JURNALRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.jurnal) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LABARUGIRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.labaRugi) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const NERACARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.neraca) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  useEffect(() => {
    // const handleResize = () => setScreenSize(window.innerWidth);
    // window.addEventListener("resize", handleResize);
    // handleResize();
    // return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`app ${toggled ? "toggled" : ""}`}>
      {user && (
        <Sidebar
          collapsed={collapsed}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
          handleCollapsedChange={handleCollapsedChange}
        />
      )}

      <main>
        <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
          <FaBars />
        </div>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          {/* Profil User */}
          <Route
            path="/profilUser"
            element={
              <PROFILUSERRoute>
                <ProfilUser />
              </PROFILUSERRoute>
            }
          />
          <Route
            path="/profilUser/:id/edit"
            element={
              <PROFILUSERRoute>
                <UbahProfilUser />
              </PROFILUSERRoute>
            }
          />
          {/* Daftar User */}
          <Route
            path="/daftarUser"
            element={
              <DAFTARUSERRoute>
                <DaftarUser />
              </DAFTARUSERRoute>
            }
          />
          <Route
            path="/daftarUser/:id"
            element={
              <DAFTARUSERRoute>
                <DaftarUser />
              </DAFTARUSERRoute>
            }
          />
          <Route
            path="/daftarUser/:id/edit"
            element={
              <DAFTARUSERRoute>
                <UbahUser />
              </DAFTARUSERRoute>
            }
          />
          <Route
            path="/daftarUser/tambahUser"
            element={
              <DAFTARUSERRoute>
                <TambahUser />
              </DAFTARUSERRoute>
            }
          />
          <Route
            path="/tutupPeriode"
            element={
              <TUTUPPERIODERoute>
                <TutupPeriode />
              </TUTUPPERIODERoute>
            }
          />
          {/* Ganti Periode */}
          <Route
            path="/gantiPeriode"
            element={
              <GANTIPERIODERoute>
                <TampilGantiPeriode />
              </GANTIPERIODERoute>
            }
          />
          <Route
            path="/gantiPeriode/:id"
            element={
              <GANTIPERIODERoute>
                <TampilGantiPeriode />
              </GANTIPERIODERoute>
            }
          />
          {/* Setting */}
          <Route
            path="/setting"
            element={
              <SETTINGRoute>
                <TampilSetting />
              </SETTINGRoute>
            }
          />
          <Route
            path="/setting/:id/edit"
            element={
              <SETTINGRoute>
                <UbahSetting />
              </SETTINGRoute>
            }
          />
          {/* Kategori */}
          <Route
            path="/kategori"
            element={
              <KATEGORIRoute>
                <TampilKategori />
              </KATEGORIRoute>
            }
          />
          <Route
            path="/kategori/:id"
            element={
              <KATEGORIRoute>
                <TampilKategori />
              </KATEGORIRoute>
            }
          />
          <Route
            path="/kategori/:id/edit"
            element={
              <KATEGORIRoute>
                <UbahKategori />
              </KATEGORIRoute>
            }
          />
          <Route
            path="/kategori/tambahKategori"
            element={
              <KATEGORIRoute>
                <TambahKategori />
              </KATEGORIRoute>
            }
          />
          {/* Barang */}
          <Route
            path="/barang"
            element={
              <BARANGRoute>
                <TampilBarang />
              </BARANGRoute>
            }
          />
          <Route
            path="/barang/:id"
            element={
              <BARANGRoute>
                <TampilBarang />
              </BARANGRoute>
            }
          />
          <Route
            path="/barang/:id/edit"
            element={
              <BARANGRoute>
                <UbahBarang />
              </BARANGRoute>
            }
          />
          <Route
            path="/barang/tambahBarang"
            element={
              <BARANGRoute>
                <TambahBarang />
              </BARANGRoute>
            }
          />
          {/* Jenis COA */}
          <Route
            path="/jenisCoa"
            element={
              <BUKUBESARRoute>
                <TampilJenisCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/jenisCoa/:id"
            element={
              <BUKUBESARRoute>
                <TampilJenisCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/jenisCoa/:id/edit"
            element={
              <BUKUBESARRoute>
                <UbahJenisCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/jenisCoa/tambahJenisCoa"
            element={
              <BUKUBESARRoute>
                <TambahJenisCOA />
              </BUKUBESARRoute>
            }
          />
          {/* Group COA */}
          <Route
            path="/groupCoa"
            element={
              <BUKUBESARRoute>
                <TampilGroupCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/groupCoa/:id"
            element={
              <BUKUBESARRoute>
                <TampilGroupCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/groupCoa/:id/edit"
            element={
              <BUKUBESARRoute>
                <UbahGroupCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/groupCoa/tambahGroupCoa"
            element={
              <BUKUBESARRoute>
                <TambahGroupCOA />
              </BUKUBESARRoute>
            }
          />
          {/* Sub Group COA */}
          <Route
            path="/subGroupCoa"
            element={
              <BUKUBESARRoute>
                <TampilSubGroupCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/subGroupCoa/:id"
            element={
              <BUKUBESARRoute>
                <TampilSubGroupCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/subGroupCoa/:id/edit"
            element={
              <BUKUBESARRoute>
                <UbahSubGroupCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/subGroupCoa/tambahSubGroupCoa"
            element={
              <BUKUBESARRoute>
                <TambahSubGroupCOA />
              </BUKUBESARRoute>
            }
          />
          {/*  COA */}
          <Route
            path="/coa"
            element={
              <BUKUBESARRoute>
                <TampilCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/coa/:id"
            element={
              <BUKUBESARRoute>
                <TampilCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/coa/:id/edit"
            element={
              <BUKUBESARRoute>
                <UbahCOA />
              </BUKUBESARRoute>
            }
          />
          <Route
            path="/coa/tambahCoa"
            element={
              <BUKUBESARRoute>
                <TambahCOA />
              </BUKUBESARRoute>
            }
          />
          {/* Supplier */}
          <Route
            path="/supplier"
            element={
              <SUPPLIERRoute>
                <TampilSupplier />
              </SUPPLIERRoute>
            }
          />
          <Route
            path="/supplier/:id"
            element={
              <SUPPLIERRoute>
                <TampilSupplier />
              </SUPPLIERRoute>
            }
          />
          <Route
            path="/supplier/:id/edit"
            element={
              <SUPPLIERRoute>
                <UbahSupplier />
              </SUPPLIERRoute>
            }
          />
          <Route
            path="/supplier/tambahSupplier"
            element={
              <SUPPLIERRoute>
                <TambahSupplier />
              </SUPPLIERRoute>
            }
          />
          {/* Pelanggan */}
          <Route
            path="/pelanggan"
            element={
              <PELANGGANRoute>
                <TampilPelanggan />
              </PELANGGANRoute>
            }
          />
          <Route
            path="/pelanggan/:id"
            element={
              <PELANGGANRoute>
                <TampilPelanggan />
              </PELANGGANRoute>
            }
          />
          <Route
            path="/pelanggan/:id/edit"
            element={
              <PELANGGANRoute>
                <UbahPelanggan />
              </PELANGGANRoute>
            }
          />
          <Route
            path="/pelanggan/tambahPelanggan"
            element={
              <PELANGGANRoute>
                <TambahPelanggan />
              </PELANGGANRoute>
            }
          />
          {/* Cabang */}
          <Route
            path="/cabang"
            element={
              <CABANGRoute>
                <TampilCabang />
              </CABANGRoute>
            }
          />
          <Route
            path="/cabang/:id"
            element={
              <CABANGRoute>
                <TampilCabang />
              </CABANGRoute>
            }
          />
          <Route
            path="/cabang/:id/edit"
            element={
              <CABANGRoute>
                <UbahCabang />
              </CABANGRoute>
            }
          />
          <Route
            path="/cabang/tambahCabang"
            element={
              <CABANGRoute>
                <TambahCabang />
              </CABANGRoute>
            }
          />
          {/* Stok Toko */}
          <Route
            path="/daftarStokToko"
            element={
              <STOKTOKORoute>
                <TampilDaftarStokToko />
              </STOKTOKORoute>
            }
          />
          <Route
            path="/daftarStokToko/:id"
            element={
              <STOKTOKORoute>
                <TampilDaftarStokToko />
              </STOKTOKORoute>
            }
          />
          {/* Koreksi Stok Toko */}
          <Route
            path="/koreksiStokToko"
            element={
              <KOREKSISTOKTOKORoute>
                <TampilKoreksiStokToko />
              </KOREKSISTOKTOKORoute>
            }
          />
          <Route
            path="/koreksiStokToko/:id"
            element={
              <KOREKSISTOKTOKORoute>
                <TampilKoreksiStokToko />
              </KOREKSISTOKTOKORoute>
            }
          />
          <Route
            path="/koreksiStokToko/tambahKoreksiStokToko"
            element={
              <KOREKSISTOKTOKORoute>
                <TambahKoreksiStokToko />
              </KOREKSISTOKTOKORoute>
            }
          />
          {/* TRANSAKSI */}
          {/* Pembelian */}
          <Route
            path="/daftarBeli"
            element={
              <PEMBELIANRoute>
                <TampilDaftarBeli />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/tambahSupplier"
            element={
              <PEMBELIANRoute>
                <TambahSupplierFromBeli />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/tambahBeli"
            element={
              <PEMBELIANRoute>
                <TambahBeli />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/:id"
            element={
              <PEMBELIANRoute>
                <TampilBeli />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/:id/edit"
            element={
              <PEMBELIANRoute>
                <UbahBeli />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/:id/tambahBeliChild"
            element={
              <PEMBELIANRoute>
                <TambahBeliChild />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/:id/tambahBarang"
            element={
              <PEMBELIANRoute>
                <TambahBarangFromBeliChild />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/:id/:idBeliChild"
            element={
              <PEMBELIANRoute>
                <TampilBeliChild />
              </PEMBELIANRoute>
            }
          />
          <Route
            path="/daftarBeli/beli/:id/:idBeliChild/edit"
            element={
              <PEMBELIANRoute>
                <UbahBeliChild />
              </PEMBELIANRoute>
            }
          />
          {/* Pembayaran Hutang */}
          <Route
            path="/pembayaranHutang"
            element={
              <PEMBAYARANHUTANGRoute>
                <TampilPembayaranHutang />
              </PEMBAYARANHUTANGRoute>
            }
          />
          <Route
            path="/pembayaranHutang/:id"
            element={
              <PEMBAYARANHUTANGRoute>
                <TampilPembayaranHutang />
              </PEMBAYARANHUTANGRoute>
            }
          />
          <Route
            path="/pembayaranHutang/tambahPembayaranHutang"
            element={
              <PEMBAYARANHUTANGRoute>
                <TambahPembayaranHutang />
              </PEMBAYARANHUTANGRoute>
            }
          />
          {/* Penjualan */}
          <Route
            path="/daftarJual"
            element={
              <PENJUALANRoute>
                <TampilDaftarJual />
              </PENJUALANRoute>
            }
          />
          <Route
            path="/daftarJual/jual/tambahJual"
            element={
              <PENJUALANRoute>
                <TambahJual />
              </PENJUALANRoute>
            }
          />
          <Route
            path="/daftarJual/jual/:id"
            element={
              <PENJUALANRoute>
                <TampilJual />
              </PENJUALANRoute>
            }
          />
          <Route
            path="/daftarJual/jual/:id/edit"
            element={
              <PENJUALANRoute>
                <UbahJual />
              </PENJUALANRoute>
            }
          />
          <Route
            path="/daftarJual/jual/tambahPelanggan"
            element={
              <PENJUALANRoute>
                <TambahPelangganFromJual />
              </PENJUALANRoute>
            }
          />
          <Route
            path="/daftarJual/jual/:id/tambahJualChild"
            element={
              <PENJUALANRoute>
                <TambahJualChild />
              </PENJUALANRoute>
            }
          />
          <Route
            path="/daftarJual/jual/:id/:idJualChild"
            element={
              <PENJUALANRoute>
                <TampilJualChild />
              </PENJUALANRoute>
            }
          />
          {/* Pembayaran Piutang" */}
          <Route
            path="/pembayaranPiutang"
            element={
              <PEMBAYARANPIUTANGRoute>
                <TampilPembayaranPiutang />
              </PEMBAYARANPIUTANGRoute>
            }
          />
          <Route
            path="/pembayaranPiutang/:id"
            element={
              <PEMBAYARANPIUTANGRoute>
                <TampilPembayaranPiutang />
              </PEMBAYARANPIUTANGRoute>
            }
          />
          <Route
            path="/pembayaranPiutang/tambahPembayaranPiutang"
            element={
              <PEMBAYARANPIUTANGRoute>
                <TambahPembayaranPiutang />
              </PEMBAYARANPIUTANGRoute>
            }
          />
          {/* Laporan */}
          <Route
            path="/laporanStokBarang"
            element={
              <LAPORANSTOKBARANGRoute>
                <LaporanStokBarang />
              </LAPORANSTOKBARANGRoute>
            }
          />
          <Route
            path="/laporanPembelianBarang"
            element={
              <LAPORANPEMBELIANBARANGRoute>
                <LaporanPembelianBarang />
              </LAPORANPEMBELIANBARANGRoute>
            }
          />
          <Route
            path="/laporanPembelian"
            element={
              <LAPORANPEMBELIANRoute>
                <LaporanPembelian />
              </LAPORANPEMBELIANRoute>
            }
          />
          <Route
            path="/laporanPenjualan"
            element={
              <LAPORANPENJUALANRoute>
                <LaporanPenjualan />
              </LAPORANPENJUALANRoute>
            }
          />
          <Route
            path="/laporanPenjualanRinci"
            element={
              <LAPORANPENJUALANRoute>
                <LaporanPenjualanRinci />
              </LAPORANPENJUALANRoute>
            }
          />
          <Route
            path="/laporanBarangHpp"
            element={
              <LAPORANBARANGHPPRoute>
                <LaporanBarangHpp />
              </LAPORANBARANGHPPRoute>
            }
          />
          {/* FINANCE */}
          {/* Kas Masuk */}
          <Route
            path="/daftarKasMasuk"
            element={
              <KASMASUKRoute>
                <TampilDaftarKasMasuk />
              </KASMASUKRoute>
            }
          />
          <Route
            path="/daftarKasMasuk/kasMasuk/tambahKasMasuk"
            element={
              <KASMASUKRoute>
                <TambahKasMasuk />
              </KASMASUKRoute>
            }
          />
          <Route
            path="/daftarKasMasuk/kasMasuk/:id"
            element={
              <KASMASUKRoute>
                <TampilKasMasuk />
              </KASMASUKRoute>
            }
          />
          <Route
            path="/daftarKasMasuk/kasMasuk/:id/edit"
            element={
              <KASMASUKRoute>
                <UbahKasMasuk />
              </KASMASUKRoute>
            }
          />
          <Route
            path="/daftarKasMasuk/kasMasuk/:id/tambahKasMasukChild"
            element={
              <KASMASUKRoute>
                <TambahKasMasukChild />
              </KASMASUKRoute>
            }
          />
          <Route
            path="/daftarKasMasuk/kasMasuk/:id/:idKasMasukChild"
            element={
              <KASMASUKRoute>
                <TampilKasMasukChild />
              </KASMASUKRoute>
            }
          />
          <Route
            path="/daftarKasMasuk/kasMasuk/:id/:idKasMasukChild/edit"
            element={
              <KASMASUKRoute>
                <UbahKasMasukChild />
              </KASMASUKRoute>
            }
          />
          {/* Kas Keluar */}
          <Route
            path="/daftarKasKeluar"
            element={
              <KASKELUARRoute>
                <TampilDaftarKasKeluar />
              </KASKELUARRoute>
            }
          />
          <Route
            path="/daftarKasKeluar/kasKeluar/tambahKasKeluar"
            element={
              <KASKELUARRoute>
                <TambahKasKeluar />
              </KASKELUARRoute>
            }
          />
          <Route
            path="/daftarKasKeluar/kasKeluar/:id"
            element={
              <KASKELUARRoute>
                <TampilKasKeluar />
              </KASKELUARRoute>
            }
          />
          <Route
            path="/daftarKasKeluar/kasKeluar/:id/edit"
            element={
              <KASKELUARRoute>
                <UbahKasKeluar />
              </KASKELUARRoute>
            }
          />
          <Route
            path="/daftarKasKeluar/kasKeluar/:id/tambahKasKeluarChild"
            element={
              <KASKELUARRoute>
                <TambahKasKeluarChild />
              </KASKELUARRoute>
            }
          />
          <Route
            path="/daftarKasKeluar/kasKeluar/:id/:idKasKeluarChild"
            element={
              <KASKELUARRoute>
                <TampilKasKeluarChild />
              </KASKELUARRoute>
            }
          />
          <Route
            path="/daftarKasKeluar/kasKeluar/:id/:idKasKeluarChild/edit"
            element={
              <KASKELUARRoute>
                <UbahKasKeluarChild />
              </KASKELUARRoute>
            }
          />
          {/* Bank Masuk */}
          <Route
            path="/daftarBankMasuk"
            element={
              <BANKMASUKRoute>
                <TampilDaftarBankMasuk />
              </BANKMASUKRoute>
            }
          />
          <Route
            path="/daftarBankMasuk/bankMasuk/tambahBankMasuk"
            element={
              <BANKMASUKRoute>
                <TambahBankMasuk />
              </BANKMASUKRoute>
            }
          />
          <Route
            path="/daftarBankMasuk/bankMasuk/:id"
            element={
              <BANKMASUKRoute>
                <TampilBankMasuk />
              </BANKMASUKRoute>
            }
          />
          <Route
            path="/daftarBankMasuk/bankMasuk/:id/edit"
            element={
              <BANKMASUKRoute>
                <UbahBankMasuk />
              </BANKMASUKRoute>
            }
          />
          <Route
            path="/daftarBankMasuk/bankMasuk/:id/tambahBankMasukChild"
            element={
              <BANKMASUKRoute>
                <TambahBankMasukChild />
              </BANKMASUKRoute>
            }
          />
          <Route
            path="/daftarBankMasuk/bankMasuk/:id/:idBankMasukChild"
            element={
              <BANKMASUKRoute>
                <TampilBankMasukChild />
              </BANKMASUKRoute>
            }
          />
          <Route
            path="/daftarBankMasuk/bankMasuk/:id/:idBankMasukChild/edit"
            element={
              <BANKMASUKRoute>
                <UbahBankMasukChild />
              </BANKMASUKRoute>
            }
          />
          {/* Bank Keluar */}
          <Route
            path="/daftarBankKeluar"
            element={
              <BANKKELUARRoute>
                <TampilDaftarBankKeluar />
              </BANKKELUARRoute>
            }
          />
          <Route
            path="/daftarBankKeluar/bankKeluar/tambahBankKeluar"
            element={
              <BANKKELUARRoute>
                <TambahBankKeluar />
              </BANKKELUARRoute>
            }
          />
          <Route
            path="/daftarBankKeluar/bankKeluar/:id"
            element={
              <BANKKELUARRoute>
                <TampilBankKeluar />
              </BANKKELUARRoute>
            }
          />
          <Route
            path="/daftarBankKeluar/bankKeluar/:id/edit"
            element={
              <BANKKELUARRoute>
                <UbahBankKeluar />
              </BANKKELUARRoute>
            }
          />
          <Route
            path="/daftarBankKeluar/bankKeluar/:id/tambahBankKeluarChild"
            element={
              <BANKKELUARRoute>
                <TambahBankKeluarChild />
              </BANKKELUARRoute>
            }
          />
          <Route
            path="/daftarBankKeluar/bankKeluar/:id/:idBankKeluarChild"
            element={
              <BANKKELUARRoute>
                <TampilBankKeluarChild />
              </BANKKELUARRoute>
            }
          />
          <Route
            path="/daftarBankKeluar/bankKeluar/:id/:idBankKeluarChild/edit"
            element={
              <BANKKELUARRoute>
                <UbahBankKeluarChild />
              </BANKKELUARRoute>
            }
          />
          {/* Posting */}
          <Route
            path="/posting"
            element={
              <POSTINGRoute>
                <Posting />
              </POSTINGRoute>
            }
          />
          <Route
            path="/unposting"
            element={
              <POSTINGRoute>
                <Unposting />
              </POSTINGRoute>
            }
          />
          <Route
            path="/aktivitasBukuBesar"
            element={
              <AKTIVITASBUKUBESARRoute>
                <AktivitasBukuBesar />
              </AKTIVITASBUKUBESARRoute>
            }
          />
          <Route
            path="/neracaSaldo"
            element={
              <NERACASALDORoute>
                <NeracaSaldo />
              </NERACASALDORoute>
            }
          />
          <Route
            path="/jurnal"
            element={
              <JURNALRoute>
                <Jurnal />
              </JURNALRoute>
            }
          />
          <Route
            path="/labaRugi"
            element={
              <LABARUGIRoute>
                <LabaRugi />
              </LABARUGIRoute>
            }
          />
          <Route
            path="/neraca"
            element={
              <NERACARoute>
                <Neraca />
              </NERACARoute>
            }
          />
        </Routes>
        <Footer />
      </main>
    </div>
  );
};

export default App;
